import React, { useState } from 'react';
import TomarEntradaForm from '../components/TomarEntradaForm';
import TicketPrinter from '../components/TicketPrinter';
import { jwtDecode } from 'jwt-decode';
import { GuardarReciboService } from '../services/guardarReciboService';
import { useNavigate } from 'react-router-dom';

const PaginaEntradaConTicket = () => {
    const [mostrarTicket, setMostrarTicket] = useState(false);
    const [entradaPayload, setEntradaPayload] = useState(null);
    const [formData, setFormData] = useState(null);

    const navigate = useNavigate();

    const onVolver = () => {
        navigate(-1);
    };

    const handleFormSubmit = (payload) => {
        setEntradaPayload(payload);
        setFormData(payload);
        setMostrarTicket(true);
    };

    const handleVolver = () => {
        setMostrarTicket(false);
    };

    const handleImpresionCompleta = async (impresionOk) => {
        if (impresionOk && entradaPayload) {
            try {
                const token = localStorage.getItem('jwt');
                if (!token) throw new Error('No se encontró el token JWT');
                const decoded = jwtDecode(token);
                const empleadoEmail = decoded.sub;

                const now = new Date();
                const fechaHoraCreacion = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}T${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;

                const reciboDto = {
                    fechaHoraCreacion,
                    precioTotal: entradaPayload.totalPagar || 0,
                    cantidadPersonas: entradaPayload.cantidadTotalPersonas || 1,
                    dniAdultoResponsable: entradaPayload.dniAdultoResponsable || '',
                    correoAdultoResponsable: entradaPayload.correoAdultoResponsable || '',
                    empleado: empleadoEmail,
                    urlContrato: '',
                    tipoPago: entradaPayload.tipoPago || 'EFECTIVO'
                };

                const response = await GuardarReciboService(reciboDto);
                console.log("Recibo generado correctamente:", response);
            } catch (error) {
                console.error("Error al generar el recibo:", error);
            }
        }
    };

    return (
        <div className="bg-gray-50 min-h-screen py-8 px-4">
            <div className="max-w-4xl mx-auto">
                {!mostrarTicket ? (
                    <TomarEntradaForm
                        onFormComplete={handleFormSubmit}
                        initialFormData={formData}
                    />
                ) : (
                    <TicketPrinter
                        onVolver={handleVolver}
                        onImpresionCompleta={handleImpresionCompleta}
                        cantTicket={entradaPayload?.cantidadTotalPersonas}
                    />
                )}
                <div className="max-w-3xl mx-auto mt-4">
                    <button onClick={onVolver} className="px-4 py-2 bg-gray-500 text-white text-sm rounded-md hover:bg-gray-600 transition-colors">Volver al Home</button>
                </div>
            </div>
        </div>
    );
};

export default PaginaEntradaConTicket;
